import { LoadingCircle } from "@givesafe/design-system-react";
import React, { Suspense, useEffect, useState } from "react";

import { ReactQueryDevtools } from "react-query/devtools";
import { useSelector } from "react-redux";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";

// import Landing from "./Landing";
import Login from "./Login";
import Registration from "./Registration";
import MagicLinkDobGate from "./MagicLinkDobGate";

const Me = React.lazy(() => import("./Me"));

const Fallback = (
  <div style={{ height: "100vh" }}>
    <LoadingCircle />
  </div>
);

function App() {
  const history = useHistory();
  const user = useSelector((s) => (s.user && s.user.data) || null);
  const errorMessage = "";
  const urlParams = new URLSearchParams(window.location?.search || "");
  const token = urlParams.get("token");
  const directToQol = urlParams.get("directToQol");
  const directToChatRoom = urlParams.get("directToChatRoom");
  const memberFormId = urlParams.get("memberFormId");
  const roomId = urlParams.get("roomId");
  const [shouldRedirectToQol, setShouldRedirectToQol] = useState(false);
  const [shouldRedirectToChatRoom, setShouldRedirectToChatRoom] = useState(false);
  const [memberFormIdFromLink, setMemberFormIdFromLink] = useState(0);
  const [chatRoomIdFromLink, setChatRoomIdFromLink] = useState(0);
  // Magic link: collect DOB first, then verify token + date_of_birth with the backend.
  const [awaitingMagicLinkDob, setAwaitingMagicLinkDob] = useState(
    () => Boolean(token)
  );

  useEffect(() => {
    if (!token) {
      return undefined;
    }

    if (directToQol) setShouldRedirectToQol(true);
    if (directToChatRoom) setShouldRedirectToChatRoom(true);
    if (memberFormId) setMemberFormIdFromLink(memberFormId);
    if (roomId) setChatRoomIdFromLink(roomId);

    return undefined;
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleMagicLinkVerified = () => {
    setAwaitingMagicLinkDob(false);
    const cleanUrl = `${window.location.pathname}${window.location.hash || ""}`;
    window.history.replaceState({}, document.title, cleanUrl);
  };

  const handleGoToLogin = () => {
    setAwaitingMagicLinkDob(false);
    history.replace("/login");
  };

  if (awaitingMagicLinkDob) {
    return (
      <MagicLinkDobGate
        token={token}
        linkSetupError={null}
        onVerified={handleMagicLinkVerified}
        onGoToLogin={handleGoToLogin}
      />
    );
  }

  return (
    <>
      <Switch>
        {user ? (
          <Redirect path="/login" to="/me" />
        ) : (
          <Route path="/login" exact render={() => <Login errorMessage={errorMessage} />} />
        )}

        {user ? (
          <Route
            path="/me"
            render={() => (
              <Suspense fallback={Fallback}>
                <Me 
                  shouldRedirectToQol={shouldRedirectToQol} memberFormIdFromLink={memberFormIdFromLink}
                  shouldRedirectToChatRoom={shouldRedirectToChatRoom} chatRoomIdFromLink={chatRoomIdFromLink}                  
                />
              </Suspense>
            )}            
          />
        
        ) : (
          <Redirect path="/me" to="/" />
        )}


        <Route path="/register" exact component={Registration} />

        <Route path="/" exact>
          {(() => {
            if (user) {
              return <Redirect to="/me" />;
            }
            return (
              <Redirect
                to={{
                  pathname: "/login",
                  state: { errorMessage }
                }}
              />
            );
          })()}
        </Route>


      </Switch>
      <ReactQueryDevtools initialIsOpen={false} />
    </>
  );
}

export default App;
